import { render, staticRenderFns } from "./CreateEventForm.vue?vue&type=template&id=c66491ca"
import script from "./CreateEventForm.vue?vue&type=script&lang=ts"
export * from "./CreateEventForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports